import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './BankAccountCard.module.css';
import cardStyles from '../../../styles/variables/cards.module.css';
import messages from './BankAccountCard.messages';
import classNames from 'classnames';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';

export class BankAccountCard extends Component {
    renderBankDetails(accountNumber, sortCode) {
        if (getCountry() === 'DE') {
            return (
                <div className={styles.accountNumber} data-testid="bank-iban">
                    <FormattedMessage {...messages.IBANNumber} />{' '}
                    <span className="fs-exclude">{accountNumber}</span>
                </div>
            );
        }

        return (
            <>
                <div
                    className={styles.accountNumber}
                    data-testid="bank-account-number"
                >
                    <FormattedMessage {...messages.bankAccountNumber} />{' '}
                    <span className="fs-exclude">{accountNumber}</span>
                </div>
                <div className={styles.sortCode} data-testid="bank-sort-code">
                    <FormattedMessage {...messages.sortCode} />{' '}
                    <span className="fs-exclude">{sortCode}</span>
                </div>
            </>
        );
    }

    render() {
        const { accountNumber, sortCode } = this.props;
        const bankAccountCardStyles = classNames(
            styles.BankAccountCard,
            cardStyles.card
        );

        return (
            <div className={bankAccountCardStyles}>
                <div className={styles.content}>
                    <div className={styles.description}>
                        <div className={styles.type}>
                            <FormattedMessage {...messages.bankAccount} />
                        </div>
                    </div>
                    <div className={styles.bankAccountInfoText}>
                        <FormattedMessage {...messages.bankAccountInfoText} />
                    </div>

                    {this.renderBankDetails(accountNumber, sortCode)}

                    {getCountry() === 'DE' && (
                        <div className={styles.changeAccountDetails}>
                            <p>
                                Um Ihre Kontodaten zu ändern, melden Sie sich
                                bitte telefonisch bei uns: 069 / 94323020
                            </p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
